import React, { useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { Collapse } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';

import AttributeSectionHeader from 'components/upb_viewer/pdp_components/AttributeSectionHeader';
import { backgroundColorStyles } from 'lib/css/colors';

function AttributeSection({ title, headerButtons, hideHeaderButtons, children }) {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <>
      <div className={css(styles.container)}>
        <div className={css(styles.header)}>
          <AttributeSectionHeader
            title={title}
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
            headerButtons={headerButtons}
            hideHeaderButtons={hideHeaderButtons}
          />
        </div>
        <Collapse in={isExpanded}>
          <div>{children}</div>
        </Collapse>
      </div>
      <hr className={classNames(css(backgroundColorStyles.greyStroke, styles.hLine))} />
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 40,
  },
  header: {
    marginBottom: 24,
  },
  hLine: {
    height: 1,
    border: 0,
  },
});

AttributeSection.propTypes = {
  title: PropTypes.string.isRequired,
  headerButtons: PropTypes.node,
  hideHeaderButtons: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default AttributeSection;
